// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { notificationsManifest } from './notifications';
import { searchSettingsManifest } from './search-settings';
import { slaManifest } from './sla';

/** Група модулів «Налаштування» (Settings): 3 модулів. */
export const settingsGroup: IModuleGroupManifest = {
  key: 'settings',
  category: 'Settings',
  name: { en: 'Settings', uk: 'Налаштування' },
  sort: 7,
  modules: [notificationsManifest, searchSettingsManifest, slaManifest],
};
